export enum StatistiquesIndicatorType {
  NbAssocViaOutil = 'no-of-associations-connected',
  NbAssocAyant = 'associations-with-indicators',
  NbAssocIndValides = 'associations-with-validated-indicators',
  NbAssociationsIndNonRecus = 'associations-indicators-not-sent',
}
